import React from 'react';
import PaymentForm from './PaymentForm';

class PaymentPage extends React.Component {
  render() {
    return (
      <div>
        <PaymentForm />
      </div>
    );
  }
}

export default PaymentPage;



// WEBPACK FOOTER //
// ./src/components/payment/PaymentPage.js